import React from 'react';
import { Button, Spinner } from 'react-bootstrap';
import { useFormikContext } from 'formik';

interface FormSubmitButtonProps {
  children: React.ReactNode;
  variant?: string;
  size?: 'sm' | 'lg';
  className?: string;
  disabled?: boolean;
  loadingText?: string;
  icon?: React.ReactNode;
}

export const FormSubmitButton: React.FC<FormSubmitButtonProps> = ({
  children,
  variant = 'primary',
  size,
  className = '',
  disabled = false,
  loadingText = 'Saving...',
  icon,
}) => {
  const { isSubmitting, isValid, dirty } = useFormikContext();

  return (
    <Button
      type="submit"
      variant={variant}
      size={size}
      className={className}
      disabled={disabled || isSubmitting || !isValid || !dirty}
    >
      {isSubmitting ? (
        <>
          <Spinner
            as="span"
            animation="border"
            size="sm"
            role="status"
            aria-hidden="true"
            className="me-2"
          />
          {loadingText}
        </>
      ) : (
        <>
          {icon && <span className="me-2">{icon}</span>}
          {children}
        </>
      )}
    </Button>
  );
}; 
